import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicalFeePaymentManualSearchComponent } from './medical-fee-payment-manual-search.component';
import { MedicalFeePaymentManualFilterComponent } from '../medical-fee-payment-manual-filter/medical-fee-payment-manual-filter.component';
import { SharedModule } from '../../shared.module';
import { SharedMaterialModule } from '../../shared-material.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MedicalFeePaymentManualSearchComponent,
    MedicalFeePaymentManualFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedMaterialModule,
    ReactiveFormsModule,
  ]
})
export class MedicalFeePaymentManualSearchModule { }
